import React from 'react';
import { Box } from '@10d/tend-ui-grid';
import { ToggleButtonGroupContext } from '../context.js';

/**
 * @deprecated Экспериментальное API. Не используйте в продакшене
 */
const Group = ({ onChange, children }) => {
    return (React.createElement(ToggleButtonGroupContext.Provider, { value: React.useMemo(() => ({ onChange }), [onChange]) },
        React.createElement(Box, null, children)));
};
Group.displayName = 'ToggleButton.Group';

export { Group };
